export const addressMixins = {
	methods: {
		/**
		 *  update address format
		 * */
		formatAddressSuburbPostCode(address) {
			try {
				if (address) {
					let addressArr = address.split(',');
					if (addressArr.length > 1) {
						let suburbPostCodeArr = addressArr[addressArr.length - 1].split(' ');
						if (suburbPostCodeArr.length > 0) {
							const postCode = suburbPostCodeArr[suburbPostCodeArr.length - 1];
							let suburb = '';
							for (let i = 0; i < suburbPostCodeArr.length - 2; i++) {
								if (suburbPostCodeArr[i]) {
									suburb += suburbPostCodeArr[i] + ' ';
								}
							}
		
							return suburb.trim() + ' ' + postCode;
						}
					}
				}
				return address;
			} catch (error) {
				console.error('Error formatting address:', error);
				return address;
			}
		},

		/**
		 * 
		 * @param {string} address 
		 * @returns 
		 */
		formatAddressStatePostCode(address) {
			try {
				if (address) {
					// Split the address by commas
					const parts = address.split(',');

					// The state and postcode are usually at the end after the last comma
					const lastPart = parts[parts.length - 1].trim();

					// Split the last part by spaces to separate state and postcode
					const lastParts = lastPart.split(' ');

					// Assuming the state is always before the postcode
					const state = lastParts[lastParts.length - 2]; 
					const postcode = lastParts[lastParts.length - 1]; 

					return state + ' ' + postcode;
				}
				return address ? address : '';
			} catch (error) {
				console.error('Error formatting address:', error);
				return address;
			}
		}
	}
}